<script>
export default {
	name: 'TStatusColorDot',
	props: {
		color: {
			type: String,
			default: 'neutral',
		},
		size: {
			type: String,
			default: '10px'
		}
	},
	render() {
		return (
			<svg width={this.size} height={this.size} viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
				<circle class={this.color} cx="6" cy="6" r="6"></circle>
			</svg>
		);
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';

@each $key, $value in $palette {
	&.#{$key} {
		fill: get-color($value, 'base');
	}
}

</style>
